import classNames from "classnames";

import styles from "./CardKlee.module.css";

const CardKlee: React.FC<CardKleeProps> = ({ className, title, children }) => {
  return (
    <div className={classNames(styles.card, className)}>
      {title && <div className={styles.title}>{title}</div>}
      {children}
    </div>
  );
};

type CardKleeProps = {
  className?: string;
  title?: string;
};

export default CardKlee;
